<template>
    <div class="lds-big-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.lds-big-ring {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-big-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 50px;
    height: 50px;
    margin: 8px;
    border: 4px solid #32417E;
    border-radius: 50%;
    animation: lds-big-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #32417E transparent transparent transparent;
}
.lds-big-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-big-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-big-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-big-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>